import styled from 'styled-components';

const AcquirersWrapper = styled.div`
    .content-logo{
        height: 140px
    }
`;

export default AcquirersWrapper;